module.exports = __webpack_public_path__ + "img/new-policy.52af5f7c.png";